import React from 'react'
import {Box, Flex, useMultiStyleConfig} from '@chakra-ui/react'
import {remCalc} from '../../../../theme/_utils'
import MenuVerticalCard from '../MenuVerticalCard'
import {CategoryGroupColumn, getTemplateLinks, IconLinkButton, templatePropTypes} from './shared'

export const getTemplateTwoData = (primarycategory) => {
    const singleCard = Array.isArray(primarycategory?.images)
        ? primarycategory.images[0]
        : primarycategory?.images

    return {
        categoryGroup: primarycategory?.category_group ?? [],
        links: getTemplateLinks(primarycategory),
        verticalCards: singleCard ? [singleCard] : [],
    }
}
const TemplateTwo = ({primarycategory, categoryData, locale}) => {
    const styles = useMultiStyleConfig('MenuTemplate', {variant: 'template-two'})
    const {categoryGroup, links, verticalCards} = getTemplateTwoData(primarycategory)

    return (
        <Box {...styles.templateContainer} data-primarycategory-id={primarycategory?.uid}>
            <Flex {...styles.layout} alignItems="stretch" minW="0" height="auto">
                <Flex
                    flexDir="column"
                    justifyContent="space-between"
                    minHeight="100%"
                    minW="0"
                    maxWidth={remCalc(706)}
                    flex="1 1 0"
                    gap="small.base"
                >
                    <Box {...styles.listWrapper}>
                        <Flex flexDir="column" gap="xsmall.base" direction="ltr">
                            {categoryData && categoryGroup.length > 0 && (
                                <Flex
                                    flexWrap="nowrap"
                                    gap={remCalc(20)}
                                    alignItems="flex-start"
                                    width="100%"
                                    data-testid="category-column-container"
                                >
                                    {categoryGroup.map((group) => (
                                        <CategoryGroupColumn
                                            key={group?.uid ?? group?.group_title}
                                            group={group}
                                            categoryData={categoryData}
                                            locale={locale}
                                            styles={styles}
                                            {...styles.categoryGroupColumn}
                                        />
                                    ))}
                                </Flex>
                            )}
                        </Flex>
                    </Box>

                    {links.length > 0 && (
                        <Flex flexDir="column" gap="xxsmall-1.base" alignItems="flex-start">
                            {links.map((link, idx) => (
                                <IconLinkButton
                                    key={`menu-icon-link-button-${idx}`}
                                    link={link}
                                    categoryData={categoryData}
                                    locale={locale}
                                    styles={styles}
                                />
                            ))}
                        </Flex>
                    )}
                </Flex>

                {verticalCards.map((card, idx) => (
                    <Box
                        key={card?._metadata?.uid ?? `menu-vertical-card-${idx}`}
                        {...styles.verticalCardWrapper}
                    >
                        {card && (
                            <MenuVerticalCard
                                card={card}
                                categoriesData={categoryData}
                                locale={locale}
                            />
                        )}
                    </Box>
                ))}
            </Flex>
        </Box>
    )
}

TemplateTwo.propTypes = templatePropTypes

export default TemplateTwo
